// Sparkline shapes for each indicator — normalised 0-1, ~20 points.
// Ported from bb-traderx/lib/wizard-indicators.ts (line 108+). Each curve is designed
// to *visually* match how that indicator looks on a real chart so the user can pick by
// shape recognition: RSI gentle sinusoid, ATR volatility hump, ADX trend ramp, etc.

export const INDICATOR_SHAPES: Record<string, number[]> = {
  // Oscillators (0–100ish, swing)
  rsi:   [0.45, 0.38, 0.29, 0.20, 0.18, 0.22, 0.31, 0.43, 0.55, 0.65, 0.72, 0.78, 0.74, 0.67, 0.58, 0.50, 0.44, 0.40, 0.43, 0.47],
  stoch: [0.85, 0.90, 0.82, 0.68, 0.50, 0.30, 0.15, 0.10, 0.18, 0.35, 0.55, 0.75, 0.88, 0.92, 0.85, 0.70, 0.52, 0.35, 0.22, 0.20],
  willr: [0.15, 0.10, 0.18, 0.35, 0.55, 0.72, 0.88, 0.92, 0.85, 0.68, 0.50, 0.30, 0.15, 0.10, 0.20, 0.38, 0.58, 0.75, 0.82, 0.78],
  cci:   [0.50, 0.58, 0.70, 0.85, 0.95, 0.88, 0.72, 0.55, 0.42, 0.30, 0.18, 0.10, 0.20, 0.35, 0.50, 0.60, 0.68, 0.58, 0.52, 0.50],
  macd:  [0.58, 0.64, 0.70, 0.74, 0.72, 0.66, 0.58, 0.50, 0.42, 0.34, 0.28, 0.26, 0.30, 0.38, 0.46, 0.54, 0.60, 0.62, 0.58, 0.55],
  roc:   [0.50, 0.60, 0.70, 0.75, 0.68, 0.55, 0.42, 0.30, 0.22, 0.28, 0.38, 0.50, 0.62, 0.72, 0.78, 0.70, 0.58, 0.48, 0.52, 0.50],
  mom:   [0.50, 0.58, 0.66, 0.72, 0.68, 0.60, 0.50, 0.40, 0.32, 0.36, 0.44, 0.52, 0.60, 0.68, 0.72, 0.66, 0.58, 0.52, 0.50, 0.50],
  cmo:   [0.50, 0.62, 0.75, 0.85, 0.82, 0.70, 0.55, 0.38, 0.25, 0.15, 0.18, 0.30, 0.45, 0.58, 0.68, 0.72, 0.65, 0.55, 0.50, 0.50],
  fisher:[0.50, 0.60, 0.75, 0.90, 0.95, 0.85, 0.65, 0.50, 0.35, 0.15, 0.05, 0.15, 0.35, 0.55, 0.72, 0.88, 0.92, 0.78, 0.60, 0.50],
  trix:  [0.50, 0.52, 0.56, 0.60, 0.64, 0.67, 0.68, 0.66, 0.62, 0.56, 0.50, 0.44, 0.38, 0.34, 0.33, 0.35, 0.38, 0.43, 0.47, 0.50],
  uo:    [0.52, 0.46, 0.38, 0.30, 0.26, 0.30, 0.40, 0.52, 0.62, 0.70, 0.74, 0.70, 0.62, 0.52, 0.44, 0.40, 0.44, 0.50, 0.52, 0.50],

  // Trends (smoothed lines / staircase / SAR-style)
  ema:        [0.25, 0.30, 0.36, 0.42, 0.50, 0.56, 0.60, 0.64, 0.62, 0.58, 0.55, 0.57, 0.61, 0.66, 0.70, 0.72, 0.70, 0.68, 0.72, 0.76],
  sma:        [0.22, 0.26, 0.30, 0.35, 0.41, 0.47, 0.52, 0.56, 0.58, 0.56, 0.53, 0.54, 0.57, 0.61, 0.65, 0.68, 0.67, 0.66, 0.68, 0.72],
  wma:        [0.24, 0.29, 0.35, 0.42, 0.50, 0.56, 0.61, 0.64, 0.62, 0.57, 0.53, 0.55, 0.59, 0.64, 0.68, 0.71, 0.69, 0.67, 0.70, 0.74],
  hma:        [0.28, 0.38, 0.50, 0.60, 0.66, 0.68, 0.64, 0.57, 0.50, 0.44, 0.42, 0.46, 0.54, 0.62, 0.68, 0.72, 0.70, 0.66, 0.70, 0.76],
  dema:       [0.26, 0.33, 0.42, 0.52, 0.60, 0.65, 0.66, 0.62, 0.56, 0.50, 0.47, 0.50, 0.56, 0.63, 0.69, 0.72, 0.70, 0.67, 0.71, 0.75],
  tema:       [0.28, 0.40, 0.54, 0.64, 0.70, 0.70, 0.64, 0.55, 0.46, 0.40, 0.38, 0.43, 0.52, 0.62, 0.70, 0.73, 0.70, 0.66, 0.70, 0.76],
  adx:        [0.08, 0.09, 0.11, 0.14, 0.18, 0.24, 0.32, 0.42, 0.52, 0.61, 0.68, 0.73, 0.76, 0.77, 0.76, 0.73, 0.70, 0.67, 0.64, 0.62],
  aroon:      [0.95, 0.90, 0.80, 0.65, 0.50, 0.35, 0.20, 0.10, 0.05, 0.10, 0.20, 0.35, 0.50, 0.65, 0.78, 0.88, 0.95, 0.90, 0.80, 0.70],
  psar:       [0.85, 0.82, 0.78, 0.73, 0.67, 0.60, 0.52, 0.44, 0.36, 0.28, 0.22, 0.18, 0.22, 0.30, 0.40, 0.50, 0.60, 0.68, 0.74, 0.78],
  supertrend: [0.20, 0.20, 0.20, 0.20, 0.20, 0.22, 0.25, 0.82, 0.82, 0.82, 0.82, 0.80, 0.78, 0.25, 0.22, 0.20, 0.20, 0.20, 0.20, 0.20],
  ichimoku:   [0.40, 0.42, 0.45, 0.50, 0.55, 0.60, 0.64, 0.66, 0.68, 0.67, 0.65, 0.62, 0.60, 0.58, 0.57, 0.58, 0.60, 0.63, 0.65, 0.66],

  // Channels (bands, staircase)
  bb:       [0.50, 0.48, 0.46, 0.44, 0.42, 0.40, 0.38, 0.35, 0.32, 0.28, 0.22, 0.16, 0.12, 0.20, 0.35, 0.52, 0.68, 0.78, 0.82, 0.80],
  keltner:  [0.50, 0.48, 0.46, 0.44, 0.43, 0.42, 0.40, 0.38, 0.35, 0.32, 0.28, 0.24, 0.22, 0.28, 0.38, 0.50, 0.62, 0.70, 0.74, 0.73],
  donchian: [0.30, 0.30, 0.30, 0.45, 0.45, 0.45, 0.45, 0.60, 0.60, 0.60, 0.75, 0.75, 0.75, 0.75, 0.75, 0.85, 0.85, 0.85, 0.85, 0.85],
  vwap:     [0.30, 0.34, 0.38, 0.43, 0.48, 0.52, 0.55, 0.57, 0.56, 0.54, 0.53, 0.55, 0.57, 0.60, 0.62, 0.64, 0.63, 0.62, 0.64, 0.66],

  // Volatility (spike & decay)
  atr:    [0.15, 0.14, 0.16, 0.20, 0.28, 0.42, 0.65, 0.85, 0.95, 0.92, 0.82, 0.70, 0.58, 0.48, 0.40, 0.34, 0.29, 0.24, 0.20, 0.18],
  stddev: [0.12, 0.13, 0.15, 0.20, 0.30, 0.46, 0.68, 0.88, 0.96, 0.90, 0.78, 0.65, 0.52, 0.42, 0.34, 0.28, 0.23, 0.18, 0.15, 0.13],
};

const FALLBACK = [0.5, 0.54, 0.6, 0.66, 0.7, 0.68, 0.62, 0.54, 0.46, 0.38, 0.34, 0.36, 0.42, 0.5, 0.58, 0.64, 0.66, 0.62, 0.56, 0.5];

export function getIndicatorShape(baseId: string): number[] {
  return INDICATOR_SHAPES[baseId] ?? FALLBACK;
}

/**
 * Build an SVG path string from a 0-1 normalised array, mapped into the given
 * width × height box with the supplied vertical padding (so the line doesn't kiss
 * the top/bottom edges).
 */
export function shapeToPath(values: number[], width: number, height: number, padY = 4): string {
  if (values.length === 0) return "";
  const innerH = height - padY * 2;
  const stepX = width / (values.length - 1);
  return values
    .map((v, i) => {
      const x = i * stepX;
      const y = padY + (1 - v) * innerH;
      return `${i === 0 ? "M" : "L"}${x.toFixed(2)},${y.toFixed(2)}`;
    })
    .join(" ");
}
